import { render, staticRenderFns } from "./ConfirmationDialogChangeActivityAutosharing.vue?vue&type=template&id=9350f810"
import script from "./ConfirmationDialogChangeActivityAutosharing.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogChangeActivityAutosharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports